import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

console.log('🚀 Iniciando aplicação TennisHub...');
console.log('📍 Ambiente:', import.meta.env.MODE);
console.log('🔧 Supabase URL configurada:', !!import.meta.env.VITE_SUPABASE_URL);
console.log('🔑 Supabase Key configurada:', !!import.meta.env.VITE_SUPABASE_ANON_KEY);

// Captura erros globais não tratados
window.addEventListener('error', (event) => {
  console.error('❌ Erro global capturado:', event.error);
  console.error('❌ Mensagem:', event.message);
  console.error('❌ Arquivo:', event.filename);
  console.error('❌ Linha:', event.lineno);
  console.error('❌ Stack:', event.error?.stack);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('❌ Promise rejeitada não tratada:', event.reason);
  console.error('❌ Stack:', event.reason?.stack);
});

try {
  console.log('📦 Renderizando App...');
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    throw new Error('Elemento root não encontrado no DOM');
  }
  
  createRoot(rootElement).render(<App />);
  console.log('✅ App renderizado com sucesso');
} catch (error) {
  console.error('❌ Erro fatal ao inicializar aplicação:', error);
  console.error('❌ Stack:', (error as Error)?.stack);
  
  // Mostra erro visual na tela
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; font-family: system-ui, -apple-system, sans-serif;">
      <div style="max-width: 600px; background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 24px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <h1 style="color: #dc2626; margin: 0 0 16px 0; font-size: 24px;">❌ Erro ao Carregar</h1>
        <p style="color: #374151; margin: 0 0 16px 0;">Ocorreu um erro ao inicializar a aplicação.</p>
        <details style="margin-top: 16px;">
          <summary style="cursor: pointer; color: #6b7280; font-size: 14px;">Detalhes técnicos</summary>
          <pre style="margin-top: 8px; padding: 12px; background: #f3f4f6; border-radius: 4px; overflow-x: auto; font-size: 12px; color: #1f2937;">${(error as Error)?.message || 'Erro desconhecido'}\n\n${(error as Error)?.stack || ''}</pre>
        </details>
        <button onclick="window.location.reload()" style="margin-top: 16px; padding: 8px 16px; background: #2563eb; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">Recarregar Página</button>
      </div>
    </div>
  `;
}
